<div class="flex-container">
  <div class="flex-item">
    <h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
    <h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

    <div style="display: flex; justify-content: start; flex-direction: row;">
      <div>
        <mat-button-toggle-group #btngroupAbsolutAnteil="matButtonToggleGroup" appearance="standard"
                                 id="btnTogglegroupAbsolutAnteil" name="btnTogglegroupAbsolutAnteil" [value]="absolut"
                                 aria-label="Anzahl or Anteil">
          <mat-button-toggle value="{{absolut}}" (change)="selectionAbsolutAnteilChanged($event)">
            <small>{{ 'i18n.cockpit.card.chart.lohnverteilung.anzahl' | translate }}</small>
          </mat-button-toggle>

          <mat-button-toggle value="{{anteil}}" (change)="selectionAbsolutAnteilChanged($event)">
            <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteil' | translate }}</small>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="diagram-margin">
        <mat-button-toggle-group #groupGestapeltUngestepelt="matButtonToggleGroup" appearance="standard"
                                 id="btnTogglegroupGestapeltUngestepelt" name="btnTogglegroupGestapeltUngestepelt"
                                 [value]="ungestapelt" aria-label="Ungestepelt or Gestapelt">
          <mat-button-toggle value="{{ungestapelt}}"
                             (change)="selectionGestapeltUngestepeltChanged($event)">
            <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.ungestapelt' | translate }}</small>
          </mat-button-toggle>
          <mat-button-toggle value="{{gestapelt}}"
                             (change)="selectionGestapeltUngestepeltChanged($event)">
            <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.gestapelt' | translate }}</small>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div id="svgContainerChartKompetenzniveau"></div>
    <div style="margin-bottom: 30px;"></div>
  </div>
</div>
